var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-text',[_c('v-checkbox',{attrs:{"label":"Customer will not be charged for this item at checkout","dense":""},model:{value:(_vm.confirm),callback:function ($$v) {_vm.confirm=$$v},expression:"confirm"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }